<template>
    <div class="EsqueciMinhaSenha" >
        <b-modal ref="esqueci-senha" id="modalEsqueciSenha" size="lg" :hide-footer="true" :hide-header="true" body-class="m-modal-body" content-class="wrapper top-flashlight leftside light-xl" modal-class="rbt-modal-box share-modal" centered>
            <h5 class="title txt-black">Esqueceu sua senha ?</h5>
            <button class="close-button" data-bs-dismiss="modal" @click="close">
                <i class="feather-x"></i>
            </button>
            <div class=" p-3">
                <p class="txt-black">Informe seu e-mail de login para enviarmos uma nova senha.</p>

                <form class="" id="formEsqueciSenha">
                    <div class="form-group">
                        <h6 for="email">E-mail</h6>
                        <input type="email" id="email" placeholder="Digite seu e-mail" v-model="email" maxlength="100" required>
                    </div>

                    <button class="btn-default bg-solid-primary w-100 mt-5" type="button" @click="enviar">Enviar</button>
                </form>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'EsqueciMinhaSenha',
        data: function () {
            return {
                email: null,
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            validar() {
                if (this.email == '' || this.email == null) {
                    return false;
                }

                return true;
            }
        },
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Auth/forgotPassword`, { login: $this.email })
                        .then(function(){
                            avisoSucesso("Sua solicitação foi registrada, verifique seu e-mail!");
                            $this.$refs['modal-esqueci-senha'].hide();
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data.msg);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formEsqueciSenha')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            close() {
                this.$refs['esqueci-senha'].hide();
            }
        },
        created: function () {
            
        },
        watch: {
            showModal: function () {
                this.$refs['esqueci-senha'].show();
            },
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* MODAL ESQUECI MINHA SENHA */
    
    .form-control {
        border: 1px solid #474747;
    }

    .modalmeusdados h1 {
        font-family: 'Sofia Sans', sans-serif;
        color: #041A1C;
        font-size: 24px;
        font-weight: 600;
    }

    .modalmeusdados p {
        font-family: 'Sofia Sans', sans-serif;
        color: #535353;
        font-weight: 300;
        font-size: 20px;
        margin-bottom: 15px;
    }

    .modalmeusdados {
        --bs-modal-width: 700px !important;
    }

        .modalmeusdados .modal-content {
            padding: 17px;
        }

        .modalmeusdados label {
            width: 100%;
        }

            .modalmeusdados label input {
                border: #0b31376b 1px solid;
                padding: 10px 1em;
                width: 100%;
            }

        .modalmeusdados h6 {
            font-family: 'Sofia Sans', sans-serif;
            color: #041A1C;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 0;
            padding-bottom: 0;
            margin-top: 15px;
        }

        .modalmeusdados form button {
            font-family: 'Sofia Sans', sans-serif;
            color: #ffffffff;
            font-weight: 600;
            font-size: 20px;
            text-transform: uppercase;
            background-color: #19555B;
            padding: 12px 0;
            border: 0;
            margin-top: 15px;
            text-align: center;
            width: 100%;
        }

            .modalmeusdados form button:hover {
                background-color: #65ebff;
                color: #111;
            }


</style>

